export const getStylesTemplate = (t: (key: string) => string) => [
  {
    title: t("stylesTemplate.text"),
    styles: [
      {
        title: t("stylesTemplate.textDark"),
        key: "tint-text-dark",
        type: "color",
      },
      {
        title: t("stylesTemplate.textLight"),
        key: "tint-text-light",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.button"),
    styles: [
      {
        type: "separator",
      },
      {
        type: "buttonExample",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.primaryBackground"),
        key: "tint-button-primary-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBackgroundHover"),
        key: "tint-button-primary-background-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBackgroundActive"),
        key: "tint-button-primary-background-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBackgroundDisabled"),
        key: "tint-button-primary-background-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.secondaryBackground"),
        key: "tint-button-secondary-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBackgroundHover"),
        key: "tint-button-secondary-background-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBackgroundActive"),
        key: "tint-button-secondary-background-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBackgroundDisabled"),
        key: "tint-button-secondary-background-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.primaryText"),
        key: "tint-button-primary-text",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryTextHover"),
        key: "tint-button-primary-text-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryTextActive"),
        key: "tint-button-primary-text-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryTextDisabled"),
        key: "tint-button-primary-text-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.secondaryText"),
        key: "tint-button-secondary-text",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryTextHover"),
        key: "tint-button-secondary-text-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryTextActive"),
        key: "tint-button-secondary-text-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryTextDisabled"),
        key: "tint-button-secondary-text-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.primaryBorder"),
        key: "tint-button-primary-border",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBorderHover"),
        key: "tint-button-primary-border-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBorderActive"),
        key: "tint-button-primary-border-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.primaryBorderDisabled"),
        key: "tint-button-primary-border-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.secondaryBorder"),
        key: "tint-button-secondary-border",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBorderHover"),
        key: "tint-button-secondary-border-hover",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBorderActive"),
        key: "tint-button-secondary-border-active",
        type: "color",
      },
      {
        title: t("stylesTemplate.secondaryBorderDisabled"),
        key: "tint-button-secondary-border-disabled",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.primaryBorderWidth"),
        key: "tint-button-primary-border-width",
        type: "size",
      },
      {
        title: t("stylesTemplate.primaryBorderWidthHover"),
        key: "tint-button-primary-border-width-hover",
        type: "size",
      },
      {
        title: t("stylesTemplate.primaryBorderWidthActive"),
        key: "tint-button-primary-border-width-active",
        type: "size",
      },
      {
        title: t("stylesTemplate.primaryBorderWidthDisabled"),
        key: "tint-button-primary-border-width-disabled",
        type: "size",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.secondaryBorderWidth"),
        key: "tint-button-secondary-border-width",
        type: "size",
      },
      {
        title: t("stylesTemplate.secondaryBorderWidthHover"),
        key: "tint-button-secondary-border-width-hover",
        type: "size",
      },
      {
        title: t("stylesTemplate.secondaryBorderWidthActive"),
        key: "tint-button-secondary-border-width-active",
        type: "size",
      },
      {
        title: t("stylesTemplate.secondaryBorderWidthDisabled"),
        key: "tint-button-secondary-border-width-disabled",
        type: "size",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.smallButtonBorderRadius"),
        key: "tint-button-sm-radius",
        type: "size",
      },
      {
        title: t("stylesTemplate.baseButtonBorderRadius"),
        key: "tint-button-base-radius",
        type: "size",
      },
      {
        title: t("stylesTemplate.largeButtonBorderRadius"),
        key: "tint-button-lg-radius",
        type: "size",
      },
    ],
  },
  {
    title: t("stylesTemplate.badges"),
    styles: [
      {
        title: t("stylesTemplate.badgeRecommended"),
        key: "tint-item-badge-recommended",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeApplied"),
        key: "tint-item-badge-applied",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.badgeRecommendedText"),
        key: "tint-item-badge-recommended-text",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeAppliedText"),
        key: "tint-item-badge-applied-text",
        type: "color",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.badgeRadius"),
        key: "tint-item-badge-radius",
        type: "size",
      },
    ],
  },
  {
    title: t("stylesTemplate.navbar"),
    styles: [
      {
        title: t("stylesTemplate.navbarBackground"),
        key: "tint-navbar-background",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.notification"),
    styles: [
      {
        title: t("stylesTemplate.notificationBackground"),
        key: "tint-notification-background",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.tabs"),
    styles: [
      {
        title: t("stylesTemplate.tabColor"),
        key: "tint-tab-color",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.analysis"),
    styles: [
      {
        title: t("stylesTemplate.badgeColor"),
        key: "tint-face-analysis-badge-color",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeRadius"),
        key: "tint-face-analysis-badge-radius",
        type: "size",
      },
      {
        type: "separator",
      },
      {
        title: t("stylesTemplate.faceBorderColor"),
        key: "tint-face-analysis-color",
        type: "color",
      },
      {
        title: t("stylesTemplate.faceBorderNoLightColor"),
        key: "tint-face-analysis-no-light-color",
        type: "color",
      },
      {
        title: t("stylesTemplate.faceBorderOkColor"),
        key: "tint-face-analysis-ok-color",
        type: "color",
      },
    ],
  },
  {
    title: t("stylesTemplate.mobileCartBadge"),
    styles: [
      {
        title: t("stylesTemplate.badgeBackground"),
        key: "tint-mobile-fab-background",
        type: "color",
      },
      {
        title: t("stylesTemplate.badgeRadius"),
        key: "tint-mobile-fab-radius",
        type: "size",
      },
    ],
  },
]
